import { GLOBAL_CHAT_ID, GLOBAL_CHAT_ID_ALTERNATIVE } from '../../constants'

export function isGlobalChat(groupId: string) {
  return groupId === GLOBAL_CHAT_ID || groupId === GLOBAL_CHAT_ID_ALTERNATIVE
}
